import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { fetchGroups, fetchGroupCategories } from '../../actions/products_actions';
import { fetchPosReport, setValue } from '../../actions/sales_actions';
import { fetchRegisters, fetchRegisterSessions, fetchAllRegisterSessions, fetchRegisterSessionsByDate, setField } from '../../actions/pos_actions';
import PosReport from '../../components/Sales/posReport';

const posReport = reduxForm({
  form: 'posReport',
})(PosReport);

const selector = formValueSelector('posReport');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  // const FromDate = selector(state, 'FromDate');
  // const ToDate = selector(state, 'ToDate');
  const StartError = selector(state, 'StartError');
  const EndError = selector(state, 'EndError');
  const Types = selector(state, 'Types');

  return {
    Days,
    // FromDate,
    // ToDate,
    Types,
    StartError,
    EndError,

    groups: state.products.groups,
    groupIsLoading: state.products.groupIsLoading,
    groupError: state.products.groupError,

    groupCategories: state.products.groupCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,

    posReport: state.salesOrders.posReport,
    posReportIsLoading: state.salesOrders.posReportIsLoading,
    posReportError: state.salesOrders.posReportError,

    registers: state.pos.registers,
    registersIsLoading: state.pos.registersIsLoading,
    registersError: state.pos.registersError,
    sessions: state.pos.sessions,
    sessionsIsLoading: state.pos.sessionsIsLoading,
    sessionsError: state.pos.sessionsError,
    FromDate: state.pos.fromDate,
    ToDate: state.pos.toDate,
    registerID: state.pos.registerID,

    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  fetchGroups, fetchGroupCategories, fetchAllRegisterSessions, fetchPosReport, setValue, setField, fetchRegisters, fetchRegisterSessions, fetchRegisterSessionsByDate
})(posReport);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/posReport.jsx